import { contactInfo } from '../data/mock';
import React from 'react';
import { Shield, Mail, MessageSquare, Youtube, Twitter } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-page border-t border-gray-800 py-16">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2 space-y-6">
            <div className="flex items-center space-x-3">
              <img 
                src={`${process.env.PUBLIC_URL}/images/logo.png?v=20250902`} 
                alt="Prototype eSports Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h3 className="heading-3 text-primary">Prototype eSports</h3>
                <p className="caption text-secondary">{t('footer.tagline')}</p>
              </div>
            </div>
            
            <p className="body-medium text-secondary max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 text-primary mb-6">{t('footer.quickLinks')}</h4>
            <div className="space-y-3">
              {[
                { name: t('nav.home'), href: '#home' },
                { name: t('nav.team'), href: '#team' },
                { name: t('nav.about'), href: '#about' },
                { name: t('nav.contact'), href: '#contact' }
              ].map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="block nav-link text-left p-0 hover:text-primary transition-colors"
                >
                  {link.name}
                </button>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3 text-primary mb-6">{t('footer.contact')}</h4>
            <div className="space-y-4">
              <div>
                <div className="body-medium text-secondary">
                <button className="text-secondary hover:text-primary transition-colors body-medium" 
                  onClick={() => window.open(contactInfo.social.discord, '_blank')}
                >
                  {t('footer.discord')}
                </button>
                </div>
              </div>
              <div>
                <div className="caption text-primary">{t('footer.community')}</div>
                <div className="body-medium text-secondary">{t('footer.communityCount')}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="text-secondary body-medium">
            © {currentYear} Prototype eSports. {t('footer.copyright')}
          </div>
          
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <button className="text-secondary hover:text-primary transition-colors body-medium">
              {t('footer.privacy')}
            </button>
            <button className="text-secondary hover:text-primary transition-colors body-medium">
              {t('footer.terms')}
            </button>
            <button className="text-secondary hover:text-primary transition-colors body-medium">
              {t('footer.codeOfConduct')}
            </button>
          </div>
        </div>

        {/* Achievement Badge */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center space-x-3 px-6 py-3 bg-secondary-olive rounded-full">
            <Shield className="text-yellow-400" size={24} />
            <span className="body-medium text-primary font-semibold">
              {t('footer.achievement')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;